import Cookies from "universal-cookie";

export const TOKEN_KEY_APP = import.meta.env.REACT_APP_TOKEN_KEY_APP;
export const TOKEN_KEY = `${TOKEN_KEY_APP}.token`;
export const REFRESH_KEY = `${TOKEN_KEY_APP}.refresh`;

/**
 * Env vars arrive as strings, so `REACT_APP_DEBUG=false` was previously truthy
 * and silently selected the debug cookie options in production.
 */
export const DEBUG = String(import.meta.env.REACT_APP_DEBUG) === "true";

/**
 * The backend mints these JWTs without an `exp` claim (getbarcart
 * `utils/helpers.py` encode_jwt), so this cookie lifetime is currently the only
 * thing bounding a token's usefulness. Shorten it once the token carries its
 * own expiry.
 */
const MAX_AGE_SECONDS = 60 * 60 * 24 * 30; // 30 days

/**
 * Cookie attributes. These must be identical on set and remove: universal-cookie
 * matches on name + path + domain, so removing without them leaves a
 * domain-scoped cookie in place and the customer stays signed in.
 */
const cookieOptions = () => ({
  path: "/",
  ...(DEBUG ? {} : { domain: ".getbarcart.com", secure: true }),
  sameSite: "lax",
});

const readCookies = () => new Cookies(document.cookie);

export const getToken = () => readCookies().get(TOKEN_KEY);

export const getRefreshToken = () => readCookies().get(REFRESH_KEY);

const setCookie = (key, value) => {
  new Cookies().set(key, value, { ...cookieOptions(), maxAge: MAX_AGE_SECONDS });
};

export const setToken = (token) => setCookie(TOKEN_KEY, token);

export const setRefreshToken = (refresh) => setCookie(REFRESH_KEY, refresh);

export const removeTokens = () => {
  const cookies = readCookies();
  const options = cookieOptions();
  cookies.remove(TOKEN_KEY, options);
  cookies.remove(REFRESH_KEY, options);
};
